import React from "react"
import cn from "classnames"
import Box, { BoxProps } from "./Box"

export interface PaperProps extends BoxProps {
  grey?: boolean;
}

const Paper: React.FC<PaperProps> = (props: PaperProps) => {
  const className = cn("mz-paper", props.className, {
    "mz-paper--grey": props.grey,
  })

  return (
    <Box {...props} className={className}/>
  )
}

export default Paper
